import { create } from 'zustand'

const useCartStore = create((set, get) => ({
    performanceId: null,
    selectedSeats: [],
    ticketAssignments: {}, // { seatId: { ticketTypeId, holderName } }
    promoCode: null,
    promoDiscount: 0,
    lockExpiresAt: null,

    setPerformance: (performanceId) => set({
        performanceId,
        selectedSeats: [],
        ticketAssignments: {},
        promoCode: null,
        promoDiscount: 0,
        lockExpiresAt: null,
    }),

    selectSeat: (seat) => set((state) => {
        const exists = state.selectedSeats.find(s => s.id === seat.id)
        if (exists) {
            return {
                selectedSeats: state.selectedSeats.filter(s => s.id !== seat.id),
                ticketAssignments: Object.fromEntries(
                    Object.entries(state.ticketAssignments).filter(([id]) => id !== String(seat.id))
                ),
            }
        }
        return { selectedSeats: [...state.selectedSeats, seat] }
    }),

    setSelectedSeats: (seats) => set({ selectedSeats: seats }),

    assignTicketType: (seatId, ticketTypeId, holderName = null) => set((state) => ({
        ticketAssignments: {
            ...state.ticketAssignments,
            [seatId]: { ticketTypeId, holderName },
        },
    })),

    setPromoCode: (code, discount) => set({
        promoCode: code,
        promoDiscount: discount
    }),

    clearPromoCode: () => set({
        promoCode: null,
        promoDiscount: 0
    }),

    setLockExpiry: (expiresAt) => set({ lockExpiresAt: expiresAt }),

    clearCart: () => set({
        performanceId: null,
        selectedSeats: [],
        ticketAssignments: {},
        promoCode: null,
        promoDiscount: 0,
        lockExpiresAt: null,
    }),

    getTicketsForOrder: () => {
        const { selectedSeats, ticketAssignments } = get()
        return selectedSeats.map(seat => ({
            seat_id: seat.id,
            ticket_type_id: ticketAssignments[seat.id]?.ticketTypeId,
            holder_name: ticketAssignments[seat.id]?.holderName,
        }))
    },

    getTotalCount: () => get().selectedSeats.length,
}))

export default useCartStore
